<template>
    <div class="lab-card" v-if="!renderless">
        <div class="lab-card__header">
            <div class="lab-card__name">{{ labName }}</div>
            <div class="lab-card__tag">{{ labPlace }}</div>
            <div class="lab-card__rating">
                <rating-stars :rating="rating"></rating-stars>
            </div>

            <template>
                <slot name="edit-button"></slot>
            </template>
        </div>

        <div class="lab-card__body">
            <div class="row no-gutters">
                <div v-for="equipment in equipmentSlots" :key="equipment.ID" class="col-sm-6 col-3">
                    <lab-card-equipment
                        :for-who-id="forWho.ID"
                        :cooking-type-id="equipments.ID"
                        :equipment-slot="equipment"
                        :equipment-selected="checkEquipment(equipment)"
                    />
                </div>
            </div>
        </div>

        <div class="lab-card__footer">
            <button
                @click="openRecommTab"
                class="btn btn-sm btn-block btn-main"
            >Улучшить лабораторию</button>
            <a
                v-if="catalogLink"
                :href="catalogLink"
                class="btn btn-sm btn-outline-main btn-block"
            >Подобрать кофе</a>
        </div>
    </div>
    <div v-else>
        <slot v-bind="{ labName, catalogLink, openRecommTab, labPlace, rating , equipmentSlots, getEquipmentRating, checkEquipment }" />
    </div>
</template>

<script>
import RatingStars from '../common/rating-stars';
import LabCardEquipment from './lab-card-equipment';

export default {
    name: 'lab-card',

    components: { RatingStars, LabCardEquipment },

    props: {
        /**
         * @type LabCard
         */
        lab: {
            type: Object,
            required: true,
        },

        equipments: {
            type: Object,
        },

        forWho: {
            type: Object,
        },

        renderless: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        labName() {
            return this.equipments?.VALUE;
        },

        labPlace() {
            return this.forWho?.VALUE;
        },

        equipmentSlots() {
            return this.equipments?.EQUIPMENT;
        },

        rating() {
            return this.lab?.UF_RATING || '';
        },

        catalogLink() {
            return this.lab.LAB_FILTER_COFFEE_QUERY ? `/coffee/?${this.lab.LAB_FILTER_COFFEE_QUERY}` : null;
        },
    },

    methods: {
        checkEquipment({ NAME: name, ID: id }) {
            /**
             * @type {LabFormDataEquipment}
             */
            const equipmentFields = {
                EQUIPMENT: '',
                BRAND: '',
                MODEL: '',
                MODEL_NEW: '',
            };

            // вариант заполнения карточек на странице списка лабораторий
            const labEquipment = this.lab.EQUIPMENT.find((item) => item.NAME === name);
            const currentEquipment = labEquipment?.PROPERTIES;

            if (currentEquipment) {
                Object.keys(equipmentFields).forEach((item) => {
                    equipmentFields[item] = currentEquipment[item].VALUE;
                });
            } else {
                // вариант для попап-окна при успешном создании лаборатории
                const equipmentsModal = Object.values(this.lab.EQUIPMENT);
                const filtered = equipmentsModal.find((equipment) => equipment?.PROPERTY_VALUES?.EQUIPMENT === id);

                if (filtered && filtered?.PROPERTY_VALUES) {
                    Object.keys(equipmentFields).forEach((item) => {
                        equipmentFields[item] = filtered?.PROPERTY_VALUES[item];
                    });
                }
            }

            return equipmentFields;
        },

        getEquipmentRating({ NAME: name, ID: id }) {
            let rating = '0';

            const currentEquipment = this.lab.EQUIPMENT.find((item) => item.NAME === name);

            if (currentEquipment) {
                rating = currentEquipment?.PROPERTIES?.rating.VALUE;
            } else {
                const equipmentsModal = this.lab.EQUIPMENT;
                const filtered = equipmentsModal.find((equipment) => equipment?.PROPERTY_VALUES?.EQUIPMENT === id);

                if (filtered && filtered?.PROPERTY_VALUES?.rating) {
                    rating = filtered?.PROPERTY_VALUES?.rating;
                }
            }

            return rating;
        },

        openRecommTab() {
            $('.nav-tabs-wr [href="#profile-recomm"]').tab('show');
        },
    },
};
</script>
